import { toast } from "react-toastify";

import { useTypedQuery } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDBBPortalQuery = (appointment_id: number) => {
  const { isFetching, refetch } = useTypedQuery({
    queryKey: AppointmentDetailsKeys.dbbPortalUrl,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id: appointment_id }, baseUrl)).data.url,
    enabled: false
  });

  const openDBBPortal = async () => {
    const { data: url, error } = await refetch();
    if (error) return toast.error(error.message);

    if (url) window.open(url, "_blank");
  };

  return { openDBBPortal, isFetching };
};
